export default async function copyText(value) {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(value);
    return;
  }

  // Резервный путь нужен локальной HTTP-разработке и старым браузерам, где Clipboard API
  // недоступен. Временное поле сразу удаляется и не влияет на разметку статьи.
  const field = document.createElement('textarea');
  field.value = value;
  field.setAttribute('readonly', '');
  field.style.position = 'fixed';
  field.style.opacity = '0';
  document.body.appendChild(field);
  field.select();
  document.execCommand('copy');
  field.remove();
}
flarum.reg.add('devconnect-articles', 'forum/service/clipboard', copyText);